/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExternalKey,
} from '../models/index';
import {
    ExternalKeyFromJSON,
    ExternalKeyToJSON,
} from '../models/index';

export interface GetExternalKeysByEntityRequest {
    entityId: number;
    type: string;
}

/**
 * 
 */
export class ExternalKeyControllerApi extends runtime.BaseAPI {

    /**
     */
    async getExternalKeysByEntityRaw(requestParameters: GetExternalKeysByEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalKey>>> {
        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling getExternalKeysByEntity().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getExternalKeysByEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("SecurityScheme", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sysadmin/exteranl-keys/entity/{entityId}/type/{type}`.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId']))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalKeyFromJSON));
    }

    /**
     */
    async getExternalKeysByEntity(requestParameters: GetExternalKeysByEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalKey>> {
        const response = await this.getExternalKeysByEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
